import type { ToggleButtonProps, ToggleGroupProps } from '@sunwebgroup/uds-ui/toggle-button'
import { ToggleButton as CssToggleButton, ToggleButtonGroup as CssToggleButtonGroup } from '@sunwebgroup/uds-ui/toggle-button'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/toggle-button' instead.
 */
export const ToggleButton = Object.assign(
  styled(CssToggleButton)<ToggleButtonProps>``,
  { displayName: 'ToggleButton' },
)

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/toggle-button' instead.
 */
export const ToggleButtonGroup = Object.assign(
  styled(CssToggleButtonGroup)<ToggleGroupProps>``,
  { displayName: 'ToggleButtonGroup' },
)
